import { load } from "./actionCreators";
import Instructor_ID from "./InstructorIDService";

export const FETCH_PRODUCTS_BEGIN = "FETCH_PRODUCTS_BEGIN";
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILURE = "FETCH_PRODUCTS_FAILURE";

export const fetchProductsBegin = () => ({
  type: FETCH_PRODUCTS_BEGIN
});

export const fetchProductsSuccess = (products, menuData) => ({
  type: FETCH_PRODUCTS_SUCCESS,
  payload: { products, menuData }
});

export const fetchProductsFailure = error => ({
  type: FETCH_PRODUCTS_FAILURE,
  payload: { error }
});

export function fetchProducts(menu = 0) {
  let domain = "api.brooklyndrives.com";
  // let domain = "ec2-54-224-126-244.compute-1.amazonaws.com";

  return async dispatch => {
    dispatch(fetchProductsBegin());

    await fetch(`https://${domain}/API/api/Appointment/` + Instructor_ID)
      .then(handleErrors)
      .then(response => {
        return response.json();
      })
      .then(myJson => {
        var cleanData = {};
        var menuData = {};
        myJson.map(rawData => {
          let tempDate = Date.parse(rawData.Date);

          cleanData[tempDate] instanceof Object
            ? cleanData[tempDate].push(rawData)
            : (cleanData[tempDate] = [rawData]);

          menuData[tempDate] instanceof Object
            ? menuData[tempDate].children.push({
                id: rawData.AppointmentID,
                Time: rawData.Time
              })
            : (menuData[tempDate] = {
                expanded: false,
                children: [{ id: rawData.AppointmentID, Time: rawData.Time }]
              });
        });

        // We are getting dates in order from the API but the times are a little messy, lets put them in order.
        // First the Main Data
        Object.keys(cleanData).map(value => {
          cleanData[value].sort((a, b) => {
            let adate = Date.parse(a.Time);
            let bdate = Date.parse(b.Time);
            return adate - bdate;
          });
        });
        // Then the menus.
        Object.keys(menuData).map(value => {
          menuData[value].children.sort((a, b) => {
            let adate = Date.parse(a.Time);
            let bdate = Date.parse(b.Time);
            return adate - bdate;
          });
        });
        //Check to see if we have loaded the menu yet. If not load it up!
        let _ = menu === 1 ? null : dispatch(load(menuData));
        // If we are good, lets load our data into the app.
        dispatch(fetchProductsSuccess(cleanData, menuData));
      })
      // If not output some errors.
      .catch(error => dispatch(fetchProductsFailure(error)));
  };
}

// Handle HTTP errors since fetch won't.
function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}
